module.exports = __webpack_public_path__ + "assets/img/47@3x.3ec91f2d.png";